// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"9c99a054","208":"7c06e8ff","272":"92b5980c","279":"4d27ae54","280":"b0fff542","646":"b4b7aa3e","686":"b797062c","694":"be8b985e","928":"4a8cea14"}[chunkId] + ".chunk.js";
};